/* eslint-disable import/prefer-default-export */

import { AUTH } from 'src/store/ActionTypes';

export const login = (username, password) => ({
  type: AUTH.LOGIN,
  payload: {
    username,
    password,
  },
});

export const passwordChallenge = (challengeName, session, username) => ({
  type: AUTH.PASSWORD_CHALLENGE,
  payload: {
    challengeName,
    session,
    username,
  },
});

export const passwordChallengeResponse = (challengeName, session, username, password) => ({
  type: AUTH.PASSWORD_CHALLENGE_RESPONSE,
  payload: {
    challengeName,
    session,
    username,
    password,
  },
});

export const forgotPassword = (username) => ({
  type: AUTH.FORGOT_PASSWORD,
  payload: username,
});

export const passwordReset = (username) => ({
  type: AUTH.PASSWORD_RESET,
  payload: username,
});

export const changePassword = (confirmationCode, username, password) => ({
  type: AUTH.CHANGE_PASSWORD,
  payload: {
    confirmationCode,
    username,
    password,
  },
});

export const logout = () => ({
  type: AUTH.LOGOUT,
});

export const resendInvitation = (username) => ({
  type: AUTH.RESEND_INVITATION,
  payload: username,
});
